var _a;
import { useMemo } from 'react';
import { appointmentNoteTypeLabels, cnAppointmentNoteTypeLabels, mmAppointmentNoteTypeLabels, } from 'constants/noteType';
import { AppointmentKind } from 'constants/appointmentKind';
var typesForAppointmentKind = (_a = {},
    _a[AppointmentKind.therapy] = appointmentNoteTypeLabels,
    _a[AppointmentKind.couplesTherapy] = appointmentNoteTypeLabels,
    _a[AppointmentKind.minorTherapy] = appointmentNoteTypeLabels,
    _a[AppointmentKind.initialCareNavigation] = cnAppointmentNoteTypeLabels,
    _a[AppointmentKind.followUpCareNavigation] = cnAppointmentNoteTypeLabels,
    _a[AppointmentKind.initialMedicationManagement] = mmAppointmentNoteTypeLabels,
    _a[AppointmentKind.followUpMedicationManagement] = mmAppointmentNoteTypeLabels,
    _a);
export var useNoteTypesForAppointment = function (appointment) {
    var noteTypeLabelsForAppointment = useMemo(function () { return typesForAppointmentKind[appointment.kind]; }, [appointment]);
    var noteTypesForAppointment = Object.keys(noteTypeLabelsForAppointment !== null && noteTypeLabelsForAppointment !== void 0 ? noteTypeLabelsForAppointment : {});
    return { noteTypesForAppointment: noteTypesForAppointment, noteTypeLabelsForAppointment: noteTypeLabelsForAppointment };
};
